import { Menu } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import ButtonDropdown from "components/Buttons/ButtonDropdown";
import { Cultures } from "models/AppModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Session from "services/Session";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    menuAnchorEl: any;
}

type Props = WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////

class HeaderLang extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            menuAnchorEl: null,
        };
    }

    private handleAction(lng: string) {
        Session.uiCulture = lng;
        this.setState({ menuAnchorEl: null });
    }

    public render() {
        if (Cultures.length < 2) {
            return null;
        }

        const flag = Cultures.find(p => p.cultures.indexOf(Session.locale) > -1);

        return (
            <>
                <ButtonDropdown
                    color="white"
                    text={<img src={`/img/flags/${flag.flag}.png`} width={24} height={24} alt={flag.name} />}
                    onClick={
                        (e) => {
                            this.setState({ menuAnchorEl: e.currentTarget });
                        }
                    }
                />
                <Menu
                    open={this.state.menuAnchorEl != null}
                    anchorEl={this.state.menuAnchorEl}
                    onClose={() => { this.setState({ menuAnchorEl: null }); }}
                >
                    {
                        Cultures.map((v, index) => (
                            <MenuItem
                                key={index}
                                onClick={(e) => this.handleAction(v.cultures[0])}>
                                <img src={`/img/flags/${v.flag}.png`} width={24} height={24} alt={v.name} />&nbsp;{v.name}
                            </MenuItem>
                        ))
                    }
                </Menu>
            </>
        );
    }
}

export default withTranslation()(HeaderLang);
